"use client";

import type { FC, Ref } from "react";

export type ContentMenuTemplateProps = Record<string, never> & {
  ref?: Ref<HTMLDivElement>;
};

/**
 * @deprecated
 */
export const ContentMenuTemplate: FC<ContentMenuTemplateProps> = ({ ref }) => (
  <div ref={ref} style={{ display: "contents" }} />
);
